import _ from 'lodash';
import Vue from 'vue';
import Vuex from 'vuex';

// modules
import ui from './modules/ui';
import overlay from './modules/overlay';
import breadCrumb from './modules/breadCrumb';
import donation from './modules/donation/donation';
import state from './modules/state';
import success from './modules/success';
import memberState from './modules/member';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    breadCrumb,
    donation,
    member: memberState,
    overlay,
    state,
    success,
    ui,
  },
});

export default store;

const resizeHandler = _.debounce(() => {
  store.commit('ui/updateWindowsWidth', window.innerWidth);
}, 100);
window.addEventListener('resize', resizeHandler);
resizeHandler();
